<bp-payment-card-brand *ngFor="let brand of brands" [src]="brand"></bp-payment-card-brand>
